/**
 * @generated SignedSource<<8af7da7dd30f7884e76f5de95669ecce>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FavoriteCellFavouriteCell$data = {
  readonly canViewIssue: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FavoriteCell">;
  readonly " $fragmentType": "FavoriteCellFavouriteCell";
};
export type FavoriteCellFavouriteCell$key = {
  readonly " $data"?: FavoriteCellFavouriteCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoriteCellFavouriteCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FavoriteCellFavouriteCell",
  "selections": [
    {
      "alias": "canViewIssue",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "VIEW_ISSUES"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"VIEW_ISSUES\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "FavoriteCell"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "efd5c8f67c62797cdd047f93f7ab55d1";

export default node;
